import classNames from 'classnames'
import React from 'react'
import style from './styles/container.module.scss'

const Container = ({ children, className = '', ...props }): React.ReactElement => {
  return (
    <div
      className={classNames({
        [style.container]: true,
        [className]: Boolean(className)
      })}
      {...props}
    >
      {children}
    </div>
  )
}

export default Container
